export const getAPIURL = () => {
 return process.env.NODE_ENV === "production"
    ? "https://api.smartcliff.in"
    // : "http://smartcliff.academy:5353"
    // : "http://3.108.109.144:5353";
    : "https://api.smartcliff.in";
};
